import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import Paper from '@mui/material/Paper'
import ClientTab from '../3modules/AccountImport/ClientTab'
import {getItemFromSessionStorage} from '../../services/util/sessionStorageManager'

const ApproveClientFormTemplate = () => {
    const navigate = useNavigate()
    const id = useParams().id
    const [clientData, setClientData] = useState({
        'accountName': '',
        'accountDescription': '',
        'accountPhoneNumber': '',
        'endCustomerName': '',
        'endCustomerId': '',
        'accountEmail': ''
    })
    const onNextClient = () => {
        navigate(`/approveClient/serviceSet/${id}`)
    }
    const onCancel = () => {
        navigate(`/adminDashboard`)
    }

    useEffect(()=>{
        const clientDataFromStorage = getItemFromSessionStorage('newClientProfile')
        if(clientDataFromStorage){
            setClientData(clientDataFromStorage)
        }
    }, [])

    return(
        <Paper sx={{ padding: '20px' }}>
            <ClientTab clientData={clientData} onCancel={onCancel} onNextClient={onNextClient} disabled/>
        </Paper>
    )
}
export default ApproveClientFormTemplate
